import expertsActive from '../assets/images/icons/experts-active.svg';
import expertsInactive from '../assets/images/icons/experts-inactive.svg';
import homeActive from '../assets/images/icons/home-active.svg';
import homeInactive from '../assets/images/icons/home-inactive.svg';
import learnActive from '../assets/images/icons/learn-active.svg';
import learnInactive from '../assets/images/icons/learn-inactive.svg';

export default [
  {
    name: 'Home',
    path: '/management/homepage',
    exact: true,
    icon: homeInactive,
    activeIcon: homeActive,
  },
  {
    name: 'Learning',
    mobileName: 'Learn',
    path: '/management/learning',
    exact: false,
    icon: learnInactive,
    activeIcon: learnActive,
  },
  {
    name: 'Experts',
    mobileName: 'Experts',
    path: '/management/experts',
    exact: false,
    icon: expertsInactive,
    activeIcon: expertsActive,
  },
  {
    name: 'Bookings',
    mobileName: 'Bookings',
    path: '/management/booking-requests',
    exact: false,
    icon: expertsInactive,
    activeIcon: expertsActive,
  },
];
